import { WorkspaceTeamScene } from '@/features/workspaces/WorkspaceTeamScene';
import { useAccountContext } from '@/features/workspaces/useAccountContext';
import { Redirect } from 'expo-router';
import { View } from 'react-native';
import { DESIGN_TOKENS } from '@/lib/design/theme';

export default function BusinessTeamTab() {
  const { currentContext, isHydrating } = useAccountContext();

  if (isHydrating) {
    return <View style={{ flex: 1, backgroundColor: DESIGN_TOKENS.colors.canvas }} />;
  }

  if (currentContext?.kind !== 'business' || !currentContext.activeOrgId) {
    return <Redirect href={'/workspaces' as never} />;
  }

  return <WorkspaceTeamScene organizationID={currentContext.activeOrgId} showSectionNav={false} />;
}
